import { render } from "./CoontactsSection.vue?vue&type=template&id=47b12626"
import script from "./CoontactsSection.vue?vue&type=script&lang=js"
export * from "./CoontactsSection.vue?vue&type=script&lang=js"

import "./CoontactsSection.vue?vue&type=style&index=0&id=47b12626&lang=css"

import exportComponent from "/opt/render/project/src/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__